import type { Channel } from './casino/casino-domain';

export type Currency = 'EUR';

export type Balance = {
  amount: number | null;
  bonus: number;
  currency: Currency;
};

export interface ErrorCode {
  type: string;
  message: string;
  errors?: ErrorCode[];
}

export interface Error {
  status: number;
  errorCode: ErrorCode;
}

export const fetchSettings: RequestInit = {
  cache: 'no-cache',
  referrerPolicy: 'strict-origin',
};

export type ApiDef<T> = {
  path: string;
  requestDef: RequestInit;
  mapper?: (response: Response) => Promise<T>;
};

// ----------------------------------

export type VaixGameClickPayload = {
  eventType: 'gameClick';
  channel: Channel;
  page: string;
  gameSlug: string;
  location: string;
  position: string;
};

export type VaixPageImpressionPayload = {
  eventType: 'pageImpression';
  channel: Channel;
  page: string;
  previousPage: string;
};

export type VaixGamesImpressionPayload = {
  eventType: 'gamesImpression';
  channel: Channel;
  page: string;
  content: VaixContentPayload[];
};

export type VaixSearchBarClickPayload = {
  eventType: 'itemClick';
  item: 'Search Focus';
  itemType: 'MENU_ITEM';
  channel: Channel;
  page: string;
};

export type VaixContentPayload = {
  location: string;
  gameSlugs: string[];
};

export type LocationConfirmPayload = {
  eventType: 'locationConfirm';
  timestamp: string;
  channel: Channel;
  confirmed: boolean;
  page: string;
};
